import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectAuxiliaryEquipment = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectAuxiliaryEquipmentData = state => selectAuxiliaryEquipment(state).data;
export const selectAuxiliaryEquipmentLoading = state => selectAuxiliaryEquipment(state).loading;
export const selectAuxiliaryEquipmentError = state => selectAuxiliaryEquipment(state).error;
export const selectAuxiliaryEquipmentMaintenanceRecordsData = state => selectAuxiliaryEquipment(state).maintenanceRecordsData;
export const selectMaintenanceRecordData = state => selectAuxiliaryEquipment(state).maintenanceRecordData;
export const selectAuxiliaryEquipmentMaintenanceData = state => selectAuxiliaryEquipment(state).maintenanceData;
export const selectCellHistoryData = state => selectAuxiliaryEquipment(state).cellHistoryData;
